<template>
  <div class="img-cmp" v-loading="loading" element-loading-text="数据正在加载中...">
    <div class="img-cmp-content" v-if="baseData?.pictures_sims?.length">
      <div class="img-left">
        <div class="img-nav">
          <div class="img-nav-title">目录{{ currentCompany }}</div>
          <div class="img-nav-menu">
            <el-collapse v-model="activeNames" accordion>
              <el-collapse-item v-for="(_item, idx) in picturesSims" :key="_item.idx" :name="_item.mulu">
                <template slot="title">
                  <div class="lvl-name">{{ `投标异常组${idx + 1}` }}</div>
                </template>
                <div class="img-nav-li" @click.stop="handleNav(item)"
                  :class="item.g_idx == currentNav ? 'img-nav-active' : ''" v-for="(item, index) in _item.pictures_sims"
                  :key="item.g_idx">异常项{{ index + 1 }} <span class="img-page">（{{ item.page }}）</span></div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
      <div class="img-right" v-loading="imgLoading" element-loading-text="图片正在加载中...">
        <div class="img-file">
          <div class="img-file-title">
<!--            <div class="w-0"></div>-->
            <span class="bt">
              【{{ currentCompany }}】- {{ activeNames }}
            </span>
            <div class="w-0">
              <span class="text-warning">图片所在第{{ baseCurrentPage }}页</span>
            </div>
          </div>
          <div class="img-file-zb">
            <el-image :src="fileUrl" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :preview-src-list="[fileUrl]"
              show-progress :initial-index="4" fit="contain">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline" style="font-size:48px;"></i>
              </div>
            </el-image>
            
          </div>
          
          <!-- <div class="img-file-zb" ref="baseContainer" @scroll="onBaseScroll">
            <div class="online-r">
              <div class="online-h" :style="{ height: totalPage * imgHeight + 'px', width: imgWidth + 'px' }">
                <template v-for="index in totalPage">
                  <div class="show-page" :data-number-page="index" v-loading="!pageInfos[index - 1].load" element-loading-text="加载中..." :ref="`basePage${index}`"
                    :style="{ top: (index - 1) * imgHeight + 'px', height: imgHeight + 'px' }">
                    <el-image :initial-index="4" :max-scale="7" :min-scale="0.2"
                      :src="pageInfos[index - 1].src" :zoom-rate="1.2"
                      fit="cover"/>
                    <div class="page-num">
                      {{ index }}/{{ totalPage }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div> -->
        </div>
        <div class="w-2"></div>
        <div class="img-file" v-if="fileFlag">
          <div class="img-file-title">
            <div class="w-0"></div>
            <span class="bt">
              【{{ unitName }}】
            </span>
            <div class="w-0">
              <span class="text-warning">图片所在第{{ cyBaseObj?.o_page }}页</span>
            </div>
          </div>
          <div class="img-file-zb" v-loading="fileCLoading" element-loading-text="图片正在加载中...">
            <el-image :src="cyBaseObj?.imgUrl" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :preview-src-list="[cyBaseObj?.imgUrl]"
              show-progress :initial-index="4" fit="contain">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline" style="font-size:48px;"></i>
              </div>
            </el-image>

          </div>
          <div class="unit-bottom">
            <div class="w-0">
              <span class="fjxx">相似比例：{{ cyBaseObj?.sim_rate }}</span>
            </div>
            <span class="file-content">{{ currentPage }}/{{ conCurrentData.length }}</span>
            <el-button type="text" size="medium" @click="handlePre">上一处</el-button>
            <el-button type="text" size="medium" @click="handleNext">下一处</el-button>
            <div class="w-0">
              <div class="sx"></div>
              <svg t="1750820981021" @click="handleSmall" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5608" width="200" height="200"><path d="M448 614.4v249.6c0 19.2-12.8 32-32 32s-32-12.8-32-32v-179.2l-198.4 198.4c-6.4 12.8-19.2 12.8-25.6 12.8s-19.2 0-25.6-6.4c-12.8-12.8-12.8-32 0-44.8L339.2 640H160c-19.2 0-32-12.8-32-32s12.8-32 32-32H448V614.4zM864 448c19.2 0 32-12.8 32-32s-12.8-32-32-32h-179.2l198.4-198.4c12.8-12.8 12.8-32 0-44.8s-32-12.8-44.8 0L640 339.2V160c0-19.2-12.8-32-32-32s-32 12.8-32 32V448h288z m32 160c0-19.2-12.8-32-32-32H576v288c0 19.2 12.8 32 32 32s32-12.8 32-32v-179.2l198.4 198.4c6.4 6.4 12.8 6.4 25.6 6.4s19.2 0 25.6-6.4c12.8-12.8 12.8-32 0-44.8L684.8 640h179.2c19.2 0 32-12.8 32-32zM416 128c-19.2 0-32 12.8-32 32v179.2L185.6 134.4c-12.8-6.4-38.4-6.4-51.2 0s-6.4 38.4 0 51.2L339.2 384H160c-19.2 0-32 12.8-32 32s12.8 32 32 32H448V160c0-19.2-12.8-32-32-32z" fill="" p-id="5609"></path></svg>
            </div>
          </div>
        </div>
        <div class="img-file" v-else>
          <div class="img-list">
            <div class="img-li" v-for="item in imgArray" :key="item.imgUrl">
              <div class="img-info">
                <div class="img-ab">
                  <div class="img-top img-content">
                    <span>{{ item.cont_name }}</span>
                  </div>
                  <el-image :src="item.imgUrl" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :preview-src-list="[item.imgUrl]"
                    show-progress :initial-index="4" fit="contain">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline" style="font-size:24px;"></i>
                    </div>
                  </el-image>
                  <div class="img-bottom img-content">
                    <span>相似度：{{ item.sim_rate }}</span>
                    <div class="w-0"></div>
                    <svg t="1750819062358" @click="handleBig(item)" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4627" width="200" height="200"><path d="M977.454545 81.454545v236.125091a34.909091 34.909091 0 0 1-69.818181 0V165.701818l-269.870546 269.870546a34.816 34.816 0 0 1-49.338182 0 34.909091 34.909091 0 0 1 0-49.384728L858.251636 116.363636h-151.831272a34.909091 34.909091 0 1 1 0.046545-69.818181h236.078546a34.909091 34.909091 0 0 1 34.90909 34.90909zM386.280727 588.381091L116.363636 858.251636v-151.924363a34.909091 34.909091 0 1 0-69.818181 0.046545v236.171637a34.909091 34.909091 0 0 0 34.90909 34.90909h236.171637a34.909091 34.909091 0 0 0 0-69.818181H165.748364l269.917091-269.917091a34.909091 34.909091 0 1 0-49.384728-49.338182zM165.748364 116.363636h151.924363A34.909091 34.909091 0 1 0 317.626182 46.545455H81.454545a34.909091 34.909091 0 0 0-34.90909 34.90909v236.125091a34.909091 34.909091 0 0 0 69.818181 0V165.701818l269.917091 269.870546a34.816 34.816 0 0 0 49.338182 0 34.909091 34.909091 0 0 0 0-49.384728L165.748364 116.363636zM942.545455 671.464727a34.909091 34.909091 0 0 0-34.909091 34.909091v151.924364l-269.870546-269.917091a34.909091 34.909091 0 1 0-49.384727 49.384727l269.870545 269.917091h-151.831272A34.909091 34.909091 0 1 0 706.466909 977.454545h236.078546a34.909091 34.909091 0 0 0 34.90909-34.90909v-236.171637a34.909091 34.909091 0 0 0-34.90909-34.909091z" fill="#231815" p-id="4628"></path></svg>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <div class="img-cmp-content" v-else>
          <div
              style="width: 100%;height: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;">
            <img alt="" src="@/assets/image/e1.png"/>
            <div
                style="
                  font-weight: 400;
                  font-style: normal;
                  font-size: 14px;
                  color: rgb(85, 85, 85);
                  margin-top: 10px;
                  line-height: 28px;
                  height: 28px;
                  text-align: center;
                "
            >
              没有异常相似哦~
            </div>
          </div>
        </div>
  </div>
</template>
<script>
import { resultByOrgNew, getPdfDataImg, getPicSimPic } from "@/api/pdf";
import { mapState } from "vuex";

export default {
  name: "NewImgCmp",
  data() {
    return {
      simNav: [],

      //       const imgWidth = ref(596);



      // const imgHeight = ref(843);

      pageInfos: [],

      totalPage: 0,

      imgHeight: 843,

      imgWidth: 596,

      picTotalSim: 0,

      picturesSims: [],

      activeNames: "",

      currentNav: "",

      baseScroll: null,

      baseCurrentPage: 1,

      baseData: {},

      file: "",

      fileUrl: "",

      loading: false,

      imgLoading: false,

      imgArray: [],

      baseObj: [],

      conCurrentData: [],

      fileFlag: false,

      unitName: '',

      currentPage: 1,

      cyBaseObj: {},

      fileCLoading: false
    }
  },
  props: {
    currentCompany: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('pdf', ['projectId', 'sign_name']),

  },
  mounted() {
    this.getPicSimPicApi(this.currentCompany);
    // this.$nextTick(()=>{
    //   this.baseScroll = this.$_.debounce(this.baseScrollChange, 500);

    //   this.baseContainer = this.$refs.baseContainer
    // })
  },
  watch: {
    currentCompany: function (val) {
      this.getPicSimPicApi(val)
    }
  },
  methods: {
    handleNext(){
      if(this.currentPage < this.conCurrentData.length){
        this.currentPage = this.currentPage + 1
      }else{
        this.currentPage = 1
      }
      this.getCurrentPage()
    },

    handlePre(){
      if(this.currentPage > 1){
        this.currentPage = this.currentPage - 1
      }else{
        this.currentPage = this.conCurrentData.length
      }
      this.getCurrentPage()
    },
    async getCurrentPage(){
      this.fileCLoading = true;
      let row = this.conCurrentData[this.currentPage - 1];

      const p = await this.getPicSimPicInfo({ file: row.cont_file, pic_name: row.o_pic_name });
      console.log(row)
      this.fileCLoading = false;
      this.cyBaseObj = { ...row, imgUrl: p.imgUrl}
    },
    handleBig(item){
      this.currentPage = 1;
      this.unitName = item.cont_name;
      this.fileFlag = true;
      this.baseObj['cont_info'].forEach(val=>{
        if(val.cont_name == item.cont_name){
          this.conCurrentData = val['cont_sims'];
        }
      })
      this.getCurrentPage()
    },

    handleSmall(){
      this.fileFlag = false;
    },
    // project=<项目>&sign_name=<签名>&file=<文件id>&pic_name=<图片文件名>
    async getPicSimPicInfo(data, obj) {

      const json = {
        project: this.projectId,
        sign_name: this.sign_name,
        ...data
      }
      const res = await getPicSimPic(json)

      return { imgUrl: res?.data?.url, ...obj };
    },
    baseScrollChange() {
      this.baseCurrentPage = Math.round(this.baseContainer.scrollTop / 843) ? Math.round(this.baseContainer.scrollTop / 843) + 1 : 1
      if (this.baseCurrentPage - 1 >= 1) {
        this.loadBasePDF(this.baseCurrentPage - 1)
      }
      this.loadBasePDF(this.baseCurrentPage)

      if (this.baseCurrentPage + 1 <= this.totalPage) {
        this.loadBasePDF(this.baseCurrentPage + 1)
      }
    },

    async loadBasePDF(page) {
      if (this.pageInfos[page - 1].load == true) {
        return;
      }
      const res = await getPdfDataImg({
        project: this.projectId,
        sign_name: this.sign_name,
        file: this.file,
        page: page
      })
      this.renderBase(page, res.data)
    },

    renderBase(page, res) {
      this.$nextTick(() => {
        if (!this.pageInfos[page - 1].load) {
          this.pageInfos[page - 1].load = true;
          this.pageInfos[page - 1].src = res.url;
          this.pageInfos[page - 1].page = page
        }
      })
    },
    onBaseScroll() {
      this.baseScroll()
    },


    async baseFun(row) {
      this.fileFlag = false;
      this.currentNav = row['g_idx'];

      this.baseCurrentPage = row['page'];

      this.baseObj = row;


      this.imgLoading = true;

      let contInfo = row['cont_info'];

      const p1 = await this.getPicSimPicInfo({ file: this.file, pic_name: row.pic_name });

      // let pAll = []

      let contImgs = contInfo.map(async val => {
        return await this.getPicSimPicInfo({ file: val['cont_sims'][0].cont_file, pic_name: val['cont_sims'][0].o_pic_name }, { sim_rate: val['cont_sims'][0]['sim_rate'], cont_name: val['cont_name'], o_page: val['cont_sims'][0]['o_page'] });
      })

      Promise.all([...contImgs]).then((res) => {
        this.imgLoading = false;
        this.imgArray = res;

        if(this.imgArray.length == 1){
          this.handleBig(this.imgArray[0])
        }
      })
      
      this.fileUrl = p1?.imgUrl;
    },
    handleNav(row) {
      this.baseFun(row)
    },
    async getPicSimPicApi(val) {
      this.loading = true;
      const json = {
        project: this.projectId,
        sign_name: this.sign_name,
        org_name: val
      }
      const res = await resultByOrgNew(json);

      this.loading = false;

      this.picTotalSim = res?.data?.pic_total_sim;

      this.picturesSims = res?.data?.details;

      this.baseData = this.picturesSims[0];

      this.activeNames = this.baseData['mulu'];

      this.totalPage = this.baseData['page_num'];

      this.file = this.baseData['file'];
      if(this.baseData['pictures_sims'].length){
        this.baseFun(this.baseData['pictures_sims'][0])
      }
      

      // this.pageInfos = this.$_.times(this.baseData['page_num'], (item) => {
      //   return {
      //     index: item,
      //     load: false,
      //     src: "",
      //     Hsrc: ""
      //   }
      // })
    }
  }
}
</script>
<style lang="scss" scoped>
.w-0 {
  width: 0;
  flex: 1;
  display: flex;
}

.img-cmp {
  display: flex;
  flex: 1;
  height: 0;
  flex-direction: column;
  margin-bottom: 10px;

  .img-cmp-content {
    height: 100%;
    width: 100%;
    border: 1px solid rgba(43, 143, 222, 1);
    position: relative;
    box-sizing: border-box;
    display: flex;

    .img-right {
      flex: 1;
      width: 0;
      display: flex;

      .img-file {
        // min-width: 608px;
        flex: 1;
        width: 0;
        flex-direction: column;
        display: flex;
        height: 100%;

        .img-list {
          width: 100%;
          height: 100%;
          overflow-y: auto;
          display: flex;
          flex-wrap: wrap;
          padding: 24px;
          box-sizing: border-box;

          .img-li {
            width: 50%;
            padding: 24px;
            box-sizing: border-box;

            .img-info {
              width: 100%;
              border: 1px solid #E4E7ED;
              box-sizing: border-box;
              height: 0;
              padding-bottom: 120%;
              overflow:hidden;
              /* 200%的高度相对于宽度 */
              
              position: relative;
              .img-ab{
                width: 100%;
                height: 100%;
                position: absolute;
                left:0;
                top:0;
                display: flex;
                align-items: center;
                justify-content: center;
                
              }
              .img-top{
                top:0;
                left:0;
                border-bottom:1px solid #E4E7ED;
              }
              .img-bottom{
                bottom:0;
                left:0;
                border-top:1px solid #E4E7ED;
              }
              .img-content{
                background: #FFFFFF;
                z-index: 1;
                position: absolute;
                height: 40px;
                width: 100%;
                // background: #333333;
                font-size: 14px;
                color: #222222;
                box-sizing: border-box;
                padding: 0 12px;
                display: flex;
                align-items:center;
                .num{
                  color:#d9001b;
                }
                .icon{
                  font-size: 14px;
                  width: 16px;
                  height: 16px;
                  cursor:pointer;
                }
              }
            }
          }
        }

        .img-file-title {
          height: 40px;
          padding: 0 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-bottom: 1px solid rgba(43, 143, 222, 1);
          color: #000000;
        }
        .unit-bottom{
          height: 40px;
          background: #d6deee;
          display:flex;
          padding:0 20px;
          align-items: center;
          font-size: 14px;
          .w-0{
            width: 0;
            flex: 1;
            display: flex;
            .sx{
              width:0;
              flex:1;
              
            }
            .icon{
              width:20px;
              height: 20px;
              cursor:pointer;
            }
          }
          .file-content{
              font-size: 14px;
              padding:0 20px;
              color: #333333;
            }
        }
        .img-file-zb {
          flex: 1;
          height: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .online-r {
            margin: 0 auto;
            width: 596px;
            position: relative;
            // width:596px;
            background: #FFFFFF;

            .online-h {
              position: relative;

              .show-page {
                width: 100%;
                position: absolute;
                overflow: hidden;
                box-sizing: border-box;
                border-bottom: 1px solid #cccccc;

                .mark-relative {
                  width: 100%;
                  height: 100%;
                  position: relative;
                  z-index: 5;

                }

                .page-mark {
                  position: absolute;
                  border: 2px solid #d9001b;
                  width: 200px;
                  height: 300px;
                  top: 10px;
                  left: 30px;
                  background: rgba(217, 0, 27, 0.2);
                }

                .page-num {
                  position: absolute;
                  left: 0;
                  right: 0;
                  bottom: 20px;
                  text-align: center;
                  font-size: 14px;
                }
              }
            }
          }
        }

      }

      .w-2 {
        height: 100%;
        width: 2px;
        border-left: 1px solid rgba(43, 143, 222, 1);
        border-right: 1px solid rgba(43, 143, 222, 1);
      }
    }

    .img-left {
      width: 200px;
    }

    .img-nav {
      width: 200px;
      background-color: #d6deee;
      padding: 10px;
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      border-right: 1px solid rgba(163, 188, 208, 1);

      .img-nav-title {
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
        color: #333333;
        height: 33px;
        line-height: 33px;
        text-align: center;
      }

      .img-nav-menu {
        flex: 1;
        height: 0;
        overflow-y: auto;
        background: #FFFFFF;

        .lvl-name {
          text-align: center;
          width: 100%;
          font-size: 14px;
        }

        .img-nav-li {
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 14px;
          position: relative;

          .img-page {
            color: #d9001b;
          }
        }

        .img-nav-active {
          background: #d6deee;
          font-weight: bold;
        }
      }
    }
  }
}

.text-warning {
  width: 100%;
  text-align: right;
  color: #d9001b;
}
</style>